<template>
    <div v-cloak>
        <div class="row">

            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }">{{ $t("inicio") }}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'configuracion' }">{{ $t("configuracion") }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{ $t("clientes") }}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>{{ $t("companya") }}</label>

                                <el-select class="select-default" size="large" v-model="idCompany" filterable
                                    :placeholder="$t('seleccionaCompania')" @change="cambioNegocio()">
                                    <el-option v-for="c in listCompany" class="select-primary" :value="c.id"
                                        :label="c.name" :key="c.name">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div v-if="listClientes.length > 0 && respuesta" class="col-md-8 text-right">
                            <label> </label><br>
                            <el-dropdown>
                                <el-button type="primary" size="small">
                                    <i class="fa fa-file"></i>
                                    {{ $t("exportarInforme") }} <i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <a :href="urlExportPDF">
                                        <el-dropdown-item class="text-danger">
                                            <strong><i class="fa fa-file-pdf"></i> {{ $t("exportarPdf") }}</strong>
                                        </el-dropdown-item>
                                    </a>
                                    <a :href="urlExportExcel">
                                        <el-dropdown-item class="text-success">
                                            <strong><i class="fa fa-file-excel"></i> {{ $t("exportarExcel") }}</strong>
                                        </el-dropdown-item>
                                    </a>
                                </el-dropdown-menu>
                            </el-dropdown>

                        </div>
                    </div>
                </div>
            </div>

            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <div class="col-md-12" v-else-if="respuesta">
                <div class="card">

                    <div class="row mb-3">
                        <div class="col-md-12">
                            <div class="form-group d-flex flex-wrap">

                                <router-link :to="{ name: 'cliente', params: { 'idCompany': idCompany } }"
                                    class="btn btn-primary mr-2 mb-2">
                                    <i class="fa fa-plus-square"></i> {{ $t("agregarCliente") }}
                                </router-link>

                                <button v-if="hasPassbookConfig" class="btn btn-primary mr-2 mb-2"
                                    @click="openSendWalletModal()">
                                    <i class="fa fa-paper-plane"></i> {{ $t("enviarWallet") }}
                                </button>

                                <!-- 5209 - Esteban (local) || 5544 - Esteban (prod) || 3536 - Valderrama -->
                                <button v-if="idCompany == 5209 || idCompany == 5544 || idCompany == 3536"
                                    class="btn btn-info active mr-2 mb-2" @click="openModalImportarClientes()">
                                    <i class="fa fa-upload"></i> {{ $t("importarExcelSaldoClientes") }}
                                </button>

                                <!-- 5209 - Esteban (local) || 5544 - Esteban (prod) || 5309 - Catering el emigrante (procavi) -->
                                <button v-if="idCompany == 5209 || idCompany == 5544 || idCompany == 5309"
                                    class="btn btn-info active mr-2 mb-2" @click="openModalImportarTarjetas()">
                                    <i class="fa fa-upload"></i> {{ $t("importarExcelTarjetas") }}
                                </button>

                            </div>

                            <div class="search-con-check mt-2 mt-md-0 pl-0 pr-0">
                                <div class="input-group search-con-check__input">
                                    <input type="text" class="form-control" :placeholder="$t('buscar')"
                                        v-model="searchQuery" @keyup.enter.prevent="searchCasas">
                                    <div class="input-group-append">
                                        <button class="btn btn-secondary" type="button" @click="searchCasas">
                                            <i class="fa fa-search"></i>
                                        </button>
                                        <button class="btn btn-secondary" type="button" @click="removeSearch">
                                            <i class="fa fa-times"></i>
                                        </button>
                                    </div>
                                </div>

                                <label class="search-con-check__label">
                                    <input type="checkbox" style="cursor: pointer; margin-right: 6px;" v-model="mostrarClientesBaja" @change="onMostrarBajasChange">
                                    {{ $t("mostrarClientesBaja") }}
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="row" v-if="isSearch">
                        <div class="col-md-12">
                            <p>
                                <small>{{ showResult }}</small>
                            </p>
                        </div>
                    </div>

                    <div class="table-responsive" v-if="loadingClientes">
                        <div class="alert alert-warning">
                            <i class="fa fa-spinner fa-spin"></i>
                            {{ $t('cargandoDatos') }}...
                        </div>
                    </div>
                    <div class="table-responsive" v-else-if="listClientes.length > 0">
                        <table class="table table-bordered table-striped">
                            <thead class="thead-dark">
                                <tr>
                                    <th>{{ $t("nombre") }}</th>
                                    <th>Código de barras</th>
                                    <!--<th>Categoría</th>-->
                                    <th>{{ $t("telefono") }}</th>
                                    <th>{{ $t("email") }}</th>
                                    <th>Saldo</th>
                                    <th>Descuento</th>
                                    <th>{{ $t("acciones") }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="c in listClientes">
                                    <td>
                                        <div>{{ c.name }} {{ c.surName }}

                                            <span style="color: red" v-if="c.active == '0'">
                                                [{{ $t("BAJA") }}]
                                            </span>

                                        </div>
                                    </td>
                                    <td width="10%">
                                        <div v-if="c.barCode != ''">
                                            {{ c.barCode }}
                                        </div>
                                        <div style="text-align: center" v-else>
                                            -
                                        </div>
                                    </td>
                                    <!--<td>
                                        <div>{{c.nameCat}}</div>
                                    </td>-->
                                    <td>
                                        <div>{{ c.phone }}</div>
                                    </td>
                                    <td>
                                        <div>{{ c.email }}</div>
                                    </td>
                                    <td width="10%" style="text-align: right;">
                                        <div>{{ c.saldo | currency }}</div>
                                    </td>
                                    <td width="10%" style="text-align: right;">
                                        <div>{{ c.dto }} %</div>
                                    </td>
                                    <td style="text-align: center;">
                                        <router-link
                                            :to="{ name: 'cliente', params: { 'idCliente': c.id, 'idCompany': idCompany, 'filtro': filter, 'pag': pag } }">
                                            <a class="btn btn-danger btn-link btn-xs">
                                                <i v-tooltip.top-center="$i18n.t('editar')" class="fas fa-pencil-alt"
                                                    style="color: orange"></i>
                                            </a>

                                        </router-link>
                                        <span v-if="hasPassbookConfig" @click="showModalPassbooks(c.id)">
                                            <a class="btn btn-danger btn-link btn-xs">
                                                <i v-tooltip.top-center="$i18n.t('passbooks')"
                                                    class="fa-solid fa-wallet" style="color: #447DF7"></i>
                                            </a>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="alert alert-danger" role="alert" v-else-if="!loadingClientes">
                        {{ $t("noHay") }} <strong>{{ $t("clientes") }}<template v-if="mostrarClientesBaja"> {{ $t("deBaja") }}</template></strong> {{ $t("enEsteNegocio") }}
                    </div>

                    <div class="row" v-if="!isSearch && totalPags > 1">
                        <div class="col-md-12">
                            <nav>
                                <ul class="pagination flex-wrap">
                                    <li class="page-item" :class="{ 'disabled': pag == 1 }">
                                        <router-link class="page-link"
                                            :to="{ name: 'clientes', params: { pag: pag - 1 } }" v-if="pag != 1">&laquo;
                                        </router-link>
                                        <span v-else class="page-link"><span aria-hidden="true">&laquo;</span></span>
                                    </li>
                                    <li class="page-item" v-for="n in totalPags" :class="{ active: n == pag }">
                                        <router-link class="page-link" :to="{ name: 'clientes', params: { pag: n } }">{{
                                            n }}
                                        </router-link>
                                    </li>
                                    <li class="page-item" :class="{ 'disabled': pag == totalPags }">
                                        <router-link class="page-link"
                                            :to="{ name: 'clientes', params: { pag: nextPag } }"
                                            v-if="pag != totalPags">
                                            &raquo;
                                        </router-link>
                                        <span v-else class="page-link"><span aria-hidden="true">&raquo;</span></span>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal :name="'compartir-passboks'" :adaptative="true" height="auto" :clickToClose="true">

            <div>
                <div class="modal-header">
                    <h4 style="margin: 0px">{{ $t("sharePassbooks") }}</h4>
                </div>
                <div style="padding-left: 10pt; padding-bottom: 10pt" v-if="clientData">
                    <template>
                        <div style="padding-left: 10pt; display: flex; align-items: center">
                            <h5 style="font-size: 16px;" v-if="idClientForPassbooks > 0"> {{ $t("cliente") }} : {{
                                $t(clientData.name) }} {{ $t(clientData.surName) }}</h5>
                        </div>
                        <div style="padding-left: 10pt; padding-bottom: 10pt;">
                            <p> {{ $t("selectBusinessForWallet") }} :</p>
                            <el-select class="select-default" v-model="idBusinessForWallet" filterable
                                :placeholder="$t('seleccionaCompania')"
                                style="padding-bottom: 10pt; padding-left: 10pt;">
                                <el-option v-for="b in listBusinesses" class="select-primary" :value="b.id"
                                    :label="b.establishmentName" :key="b.id">
                                </el-option>
                            </el-select>
                        </div>
                        <div style="padding-left: 10pt;">
                            <label for="opciones">{{ $t('sendMethod') }}:</label>
                            <div style="margin-left: 10pt;">
                                <div style="display: flex; align-items: center;">
                                    <div class="col-md-5">
                                        <input type="radio" id="nombre" v-model="shareVia" value="1" name="opcion"
                                            required>
                                        {{ $t('shareViaEmail') }}
                                    </div>
                                    <div class="col-md-6">
                                        <input type="text" class="form-control" id="nombre" v-model="clientEmail"
                                            placeholder="E-mail">
                                    </div>
                                </div>
                                <br>
                                <!--
                                <div style="display: flex; align-items: center;">
                                    <div class="col-md-5">
                                        <input type="radio" name="opcion" v-model="shareVia" value="2">
                                        {{ $t('shareViaWhatsapp') }}
                                    </div>
                                    <div class="col-md-6">
                                        <input type="text" class="form-control" id="nombre" v-model="clientPhone"
                                            placeholder="Teléfono">
                                    </div>
                                </div>
                                -->
                            </div>
                        </div>
                        <div style="padding-left: 10pt;">
                            <label for="barcode">{{ $t('barcodeUnico') }}:</label>
                            <div style="margin-left: 10pt;">
                                <div style="display: flex; align-items: center;">
                                    <div class="col-md-5">
                                        <label>{{ $t('codigoBarras') }}</label>
                                    </div>
                                    <div class="col-md-6">
                                        <input type="text" class="form-control" v-model="clientBarCode"
                                            placeholder="Barcode">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="!clientBarCode" style="padding-left: 10pt; padding-top: 25pt; color: #e60000;">
                            <label for="barcode">{{ $t('barcodeNecesarioSeActualizara') }}</label>
                        </div>
                    </template>
                </div>

                <div class="modal-footer" style="display: flex; align-items: center;">

                    <div style="padding-top: 1pt;">

                        <button class="btn" @click="copyPassbooksToClipboard()"
                            :class="{ 'disabled-button': !clientBarCode }">
                            <i class="fa fa-clipboard"></i>
                            {{ $t("copyToClipboard") }}
                        </button>
                    </div>

                    <button class="btn btn-info active" @click="sharePassbook()"
                        :class="{ 'disabled-button': !clientBarCode }">
                        {{ $t("share") }}
                    </button>


                </div>
            </div>

        </modal>

        <modal :name="'update-client-info'" :adaptative="true" height="auto" :clickToClose="true">

            <div>
                <div class="modal-header">
                    <h4 style="margin: 0px">{{ $t("sharePassbooks") }}</h4>
                </div>
                <div style="padding-left: 10pt; padding-bottom: 10pt">
                    <template>
                        <div>

                        </div>
                    </template>
                </div>

                <div class="modal-footer" style="display: flex; align-items: center;">

                    <!-- <div style="padding-top: 1pt;">

                        <button class="btn" @click="copyPassbooksToClipboard()">
                            <i class="fa fa-clipboard"></i>
                            {{ $t("copyToClipboard") }}
                        </button>
                    </div>

                    <button class="btn btn-info active" @click="sharePassbook()">
                        {{ $t("share") }}
                    </button> -->


                </div>
            </div>
        </modal>

        <modal :name="'importar-excel-clientes-valderrama'" :adaptive="true" :scrollable="true" height="auto"
            :clickToClose="false">
            <div>
                <div class="modal-header">
                    <h4 style="margin: 0px">{{ $t("importarClientes") }}</h4>
                </div>

                <div class="modal-body">
                    <template>
                        <div class="form-group">
                            <label><strong>{{ $t("archivoEnFormatoExcel") }}</strong>
                            </label>
                            <input class="form-control" type="file" style="height: 100px" @change="onFileChange" />
                            <br />
                        </div>
                    </template>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-default"
                        @click="(excel = ''), $modal.hide('importar-excel-clientes-valderrama')">
                        <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
                    </button>
                    <button class="btn btn-success" @click="previewClientData()">
                        <i class="fa fa-check-circle"></i>
                        {{ $t("preview") }}
                    </button>
                </div>
            </div>
        </modal>

        <modal :name="'importar-excel-tarjetas-procavi'" :adaptive="true" :scrollable="true" height="auto"
            :clickToClose="false">
            <div>
                <div class="modal-header">
                    <h4 style="margin: 0px">{{ $t("importarTarjetas") }}</h4>
                </div>

                <div class="modal-body">
                    <template>
                        <div class="form-group">
                            <label><strong>{{ $t("archivoEnFormatoExcel") }}</strong>
                            </label>
                            <input class="form-control" type="file" style="height: 100px" @change="onFileChange" />
                            <br />
                        </div>
                    </template>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-default"
                        @click="(excel = ''), $modal.hide('importar-excel-tarjetas-procavi')">
                        <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
                    </button>
                    <button class="btn btn-success" @click="previewTarjetasData()">
                        <i class="fa fa-check-circle"></i>
                        {{ $t("preview") }}
                    </button>
                </div>
            </div>
        </modal>

        <modal name="modal-importar" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true">
            <div class="text-center" v-if="lineasXml < 10000">
                <div class="modal-header">
                    <h4 class="modal-title col-12 text-center" style="margin: 0px">
                        {{ $t("confirmacionImportacionHeader") }}
                    </h4>
                </div>
                <div class="modal-body">
                    <div>
                        <p>{{ $t("confirmacionImportacionText") }}</p>
                        <p style="font-size: 22px">
                            <strong>{{ lineasXml }} {{ $t("registros") }}</strong>
                        </p>
                        <p style="font-size: 22px">
                            <strong>{{ $t("en") }} {{ nameCompany }}</strong>
                        </p>
                    </div>
                </div>
                <div class="modal-footer">
                    <div align="right" class="col-12">
                        <button @click="cerrarModal()" class="btn btn-danger">
                            <i class="fas fa-times"></i>
                            {{ $t("cancelar") }}
                        </button>
                        <button @click="importar()" class="btn btn-primary">
                            <i class="fas fa-check"></i>
                            {{ $t("confirmar") }}
                        </button>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="text-center">
                    <div class="modal-header">
                        <h4 class="modal-title col-12 text-center" style="margin: 0px">
                            {{ $t("headerError") }}
                        </h4>
                    </div>
                    <div class="modal-body">
                        <div>
                            <p style="font-size: 22px">{{ $t("bodyError") }}</p>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div align="right" class="col-12">
                        <button @click="cerrarModal()" class="btn btn-danger">
                            <i class="fas fa-times"></i>
                            {{ $t('cancelar') }}
                        </button>
                    </div>
                </div>
            </div>
        </modal>

        <modal :name="'enviar-passboks'" :adaptive="true" height="auto" :clickToClose="true">
            <div>
                <div class="modal-header">
                    <h4 style="margin: 0px">{{ $t("confirmacionEnvioWallet") }}</h4>
                </div>

                <div class="modal-body" style="padding: 1.5em;">
                    <p>{{ $t("confirmacionTextoEnviarWallet") }}</p>
                    <p><strong>{{ $t("mensajeConfirmacion") }}</strong></p>
                </div>

                <div class="modal-footer" style="display: flex; justify-content: flex-end; gap: 10px;">
                    <button class="btn btn-secondary" @click="closeSendWalletModal">
                        {{ $t("cancelar") }}
                    </button>
                    <button class="btn btn-primary" @click="confirmSendWallet">
                        {{ $t("enviar") }}
                    </button>
                </div>
            </div>
        </modal>


    </div>

</template>
<script>
import { DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button } from 'element-ui'
import { Loading } from 'element-ui';
import swal from 'sweetalert2'
import XLSX from 'xlsx';
import { mapState } from 'vuex';
import { name } from 'file-loader';
// import ImportarClientes from './ImportarClientes.vue';

export default {
    created() {
        this.$store.dispatch("setNameRoute", this.$i18n.t("clientes"));
        this.getCompanies();

        var filtro = this.$route.query.filtro;
        if (filtro != undefined) {
            this.filter = filtro;
        }

        this.loadingGeneral = Loading.service({ text: this.$t('cargando') });

    },
    updated() {

        this.peticionesIniciales++;

        if (this.peticionesIniciales === 2) {
            this.loadingGeneral.close();
        }

    },


    components: {
        [DatePicker.name]: DatePicker,
        [Select.name]: Select,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Button.name]: Button,
        [Option.name]: Option,
    },
    data() {
        return {
            //PRUEBAS INICIO PAGINA
            loadingGeneral: null,
            peticionesIniciales: 0,

            loading: false,
            loadingForWallet: false,
            loadingClientes: false,
            searchQuery: this.$route.params.query,
            isSearch: false,
            pag: this.$route.params.pag,
            totalPags: 0,

            respuesta: true,
            filter: 0,
            listCategoriasClientes: [],

            //CLIENTES
            idCompany: this.$route.params.idCompany,
            listCompany: [],
            listClientes: [],

            //IMPORTADOR
            excel: "",
            jsonExcel: "",
            file: "",
            nameCompany: "",
            listDatos: [],
            lineasXml: 0,
            clientImportData: [],

            idClientForPassbooks: 0,
            clientNameForPassbooks: '',
            clientData: null,
            clientEmail: '',
            clientPhone: '',
            clientBarCode: '',
            listBusinesses: [],
            shareVia: 1,
            shareViaEmail: false,
            shareViaWhatsapp: false,
            idBusinessForWallet: 0,
            copySuccess: '',
            isCopied: false,
            viaEmail: null,
            viaWhatsapp: null,

            hasPassbookConfig: false,
            idConfig: 123,
            mostrarClientesBaja: false,
        }
    },
    watch: {
        '$route'(to, from) {
            if (to.params.pag) {
                this.pag = to.params.pag;
                this.getClientes();
            } else if (to.params.query) {
                this.query = to.params.query;
                this.getClientes();
            }
        }
    },
    computed: {
        ...mapState(["permiso"]),

        showResult() {
            if (this.listClientes.length == 0) {
                return this.$t('noEncontramosResultadosPara') + this.searchQuery;
            } else {
                const result = this.listClientes.length == 1 ? this.$t('resultado') : this.$t('resultados');
                return this.$t('mostrando') + " " + this.listClientes.length + " " + result;
            }
        },
        nextPag() {
            let nextPag = parseInt(this.pag) + 1;
            return nextPag;
        },
        urlExportPDF() {
            const base = this.$store.getters.apiUrl + "/clients/exportListClients/PDF?idCompany=" + this.idCompany + "&jwt=" + this.$store.getters.jwt + "&filter=" + this.filter + "&active=" + (this.mostrarClientesBaja ? 0 : 1);
            return this.searchQuery ? base + "&search=" + encodeURIComponent(this.searchQuery) : base;
        },
        urlExportExcel() {
            const base = this.$store.getters.apiUrl + "/clients/exportListClients/Excel?idCompany=" + this.idCompany + "&jwt=" + this.$store.getters.jwt + "&filter=" + this.filter + "&active=" + (this.mostrarClientesBaja ? 0 : 1);
            return this.searchQuery ? base + "&search=" + encodeURIComponent(this.searchQuery) : base;
        },
    },
    methods: {
        selectViaWhats() {
            this.shareViaWhatsapp = !this.shareViaWhatsapp;
            // console.log(this.shareViaWhatsapp);
        },
        selectViaMail() {
            this.shareViaEmail = !this.shareViaEmail;
            // console.log(this.shareViaEmail);
        },

        getCategoryClientes() {

            const controller = 'getCategoriesClientsByCompany';
            var config = {
                params: {
                    pag: 0,
                    idCompany: this.idCompany,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "clients/" + controller, config)
                .then(function (response) {
                    if (response.data.response) {
                        vm.listCategoriasClientes = response.data.result.categoryClients;

                        let category = {
                            name: vm.$t("todos"),
                            id: 0
                        };

                        vm.listCategoriasClientes.unshift(category)
                    } else {
                        vm.loadingGeneral.close();
                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                        vm.respuesta = false;
                    }

                    // vm.loading.close();
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getCompanies() {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "general/getCompaniesByUser", config)
                .then(function (response) {

                    if (!vm.idCompany) {
                        vm.idCompany = response.data.result[0].id;
                    }
                    vm.listCompany = response.data.result;

                    vm.getClientes()
                    vm.getCompanyConfig()
                    //vm.getCategoryClientes()

                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getCompanyConfig() {

            var config = {
                params: {
                    jwt: this.$store.getters.jwt,
                    idConfig: this.idConfig,
                    idCompany: this.idCompany,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "general/getCompanyConfig", config)
                .then(function (response) {
                    if (response.data.result !== undefined) {
                        vm.hasPassbookConfig = response.data.result;
                    } else {
                        vm.hasPassbookConfig = false;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    vm.hasPassbookConfig = false;
                });
        },
        cambioNegocio() {

            this.pag = 1;
            this.totalPags = 0;
            this.filter = 0;

            this.getClientes();
            this.getCompanyConfig();
            //this.getCategoryClientes();


        },
        getClientes() {

            const controller = this.searchQuery ? 'searchClientsByCompany/' + this.searchQuery : 'getClientsByCompany';
            var config = {
                params: {
                    pag: this.pag,
                    idCompany: this.idCompany,
                    filter: this.filter,
                    active: this.mostrarClientesBaja ? 0 : 1,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            this.loadingClientes = true;
            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "clients/" + controller, config)
                .then(function (response) {
                    if (response.data.response) {
                        vm.listClientes = response.data.result.clients;
                        vm.pag = response.data.result.pag;
                        vm.totalPags = response.data.result.totalPags;
                        vm.respuesta = true;

                    } else {
                        vm.loadingGeneral.close();
                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                        vm.respuesta = false;
                    }

                    vm.loadingClientes = false;
                    //                        vm.loading.close();
                })
                .catch(function (error) {
                    console.log(error);
                    vm.loadingClientes = false;
                });
        },

        getCliente() {
            var config = {
                params: {
                    idCliente: this.idClientForPassbooks,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + 'clients/getClientById', config)
                .then(function (response) {
                    if (response.data.response) {
                        vm.clientData = response.data.result;
                        vm.clientEmail = vm.clientData.email;
                        vm.clientPhone = vm.clientData.phone;
                        vm.clientBarCode = vm.clientData.barCode;

                        vm.loadingGeneral.close();

                    } else {
                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.result,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    }

                });
        },

        getBusinessByCompany() {
            var config = {
                params: {
                    idCompany: this.idCompany,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };
            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "businesses/getBusinessesByIdCompany", config)
                .then(function (response) {
                    console.log(response.data);
                    vm.listBusinesses = response.data;
                    vm.idBusinessForWallet = vm.listBusinesses[0].id;

                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        updateCliente() {
            this.clientData.barCode = this.clientBarCode;

            var config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            var params = {
                idCompany: this.idCompany,
                cliente: this.clientData,
                jwt: this.$store.getters.jwt
            };

            let vm = this;
            return this.axios.post(this.$store.getters.apiUrl + 'clients/editClientById', params, config)
                .then(function (response) {
                    if (response.data.response) {
                        return true;
                    } else {
                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                        return false;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    return false;
                });
        },

        async sharePassbook() {
            const updateSuccess = await this.updateCliente();
            if (updateSuccess) {
                if (!this.shareVia && !this.shareViaWhatsapp) {
                    swal({
                        position: "center",
                        type: "error",
                        title: this.$t('selectOption'),
                        showConfirmButton: false,
                        timer: 2000
                    });

                    return;
                }

                if (this.shareVia == '1' && this.clientEmail == '') {
                    swal({
                        position: "center",
                        type: "error",
                        title: this.$t('verifyEmailText'),
                        showConfirmButton: false,
                        timer: 2000
                    });

                    return;
                }

                if (this.clientBarCode == '') {
                    swal({
                        position: "center",
                        type: "error",
                        title: this.$t('clientHasNoBarcode'),
                        showConfirmButton: false,
                        timer: 2000
                    });

                    return;
                }

                // console.log(this.shareVia);
                if (this.shareVia == '2' && this.clientPhone == '') {
                    swal({
                        position: "center",
                        type: "error",
                        title: this.$t('verifyNumberText'),
                        showConfirmButton: false,
                        timer: 2000
                    });

                    return;
                }

                if (this.clientEmail != this.clientData.email || this.clientPhone != this.clientData.phone) {
                    swal.fire({
                        position: "center",
                        title: this.$t('titleSaveInfoModalText'),
                        showCloseButton: true,
                        allowOutsideClick: false,
                        showConfirmButton: true,
                        showCancelButton: true,
                        confirmButtonText: this.$t('sendAndSaveButton'),
                        cancelButtonText: this.$t('sendAndNoSaveButton'),
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33'
                    }).then((result) => {
                        // console.log(result);
                        if (result.value) {
                            // Cuando se hace clic en 'Sí, enviar y guardar'
                            // console.log('Sí, enviar y guardar');
                            this.postWallets(true);
                        } else if (result.dismiss === swal.DismissReason.cancel) {
                            // Cuando se hace clic en 'No, enviar y no guardar'
                            // console.log('No, enviar y no guardar');
                            this.postWallets(false);
                        } else if (result.dismiss === swal.DismissReason.close) {
                            // Cuando se cierra el modal con la "X"
                        }
                    });
                } else {
                    this.postWallets(false);
                }
                // this.isCopied = true;
                // setTimeout(this.hideCopyTooltip(), 1000)
                this.getClientes();
            }
        },

        postWallets(toUpdate) {
            // console.log("post");
            var config = {
                params: {
                    jwt: this.$store.getters.jwt,

                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            var body = {
                clientId: parseInt(this.idClientForPassbooks),
                businessId: parseInt(this.idBusinessForWallet),
                sendMethod: parseInt(this.shareVia),
                toUpdate: toUpdate,
                email: this.clientEmail,
                phone: this.clientPhone
            }

            let vm = this;
            vm.axios.post(
                this.$store.getters.apiUrl + "clients/generatePassbookURLs",
                body,
                config)
                .then(function (response) {

                    const message = response.data[0].message;

                    if (navigator.clipboard) {
                        navigator.clipboard.writeText(message);
                    } else {
                        this.copySuccess = this.$t('clipboardFailedToCopy');
                    }

                    swal({
                        position: "center",
                        type: "success",
                        title: 'Enviado correctamente',
                        showConfirmButton: true,
                        timer: 1500
                    });


                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async copyPassbooksToClipboard() {
            const updateSuccess = await this.updateCliente();
            if (updateSuccess) {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt,

                    },
                    headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
                };

                var body = {
                    clientId: this.idClientForPassbooks,
                    businessId: this.idBusinessForWallet,
                    sendMethod: 0
                }

                let vm = this;
                vm.axios.post(
                    this.$store.getters.apiUrl + "clients/generatePassbookURLs",
                    body,
                    config)
                    .then(function (response) {

                        const message = response.data[0].message;

                        if (navigator.clipboard) {
                            navigator.clipboard.writeText(message);
                        } else {
                            this.copySuccess = this.$t('clipboardFailedToCopy');
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });

                swal({
                    position: "center",
                    type: "success",
                    title: this.$t('clipboardCopied'),
                    showConfirmButton: false,
                    timer: 1500
                });

                // this.isCopied = true;
                // setTimeout(this.hideCopyTooltip(), 1000)
                this.getClientes();
            }
        },
        hideCopyTooltip() {
            this.isCopied = false
        },
        // sendPassbooksViaEmail() {
        //     var config = {
        //         params: {
        //             jwt: this.$store.getters.jwt,
        //         },
        //         headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
        //     };

        //     var body = {
        //         idClient: this.idClientForPassbooks,
        //         toDo: 'email'
        //     }

        //     let vm = this;
        //     vm.axios.post(
        //         this.$store.getters.apiUrl + "clients/generatePassbookURLs",
        //         body,
        //         config)
        //         .then(function (response) {

        //             if (navigator.clipboard) {
        //                 navigator.clipboard.writeText(response.data);
        //             } else {
        //                 this.copySuccess = 'El API del portapapeles no está disponible en este navegador.';
        //             }


        //         })
        //         .catch(function (error) {
        //             console.log(error);
        //         });
        // },

        confirmSendWallet() {

            // Incluir solo los clientes que tengan correo y barCode configurado
            const clientData = this.listClientes
                .filter(client => client.email.trim() && client.barCode.trim())
                .map(client => ({
                    clientId: client.id,
                    email: client.email,
                    phone: client.phone || "",
                    toUpdate: false,
                    sendMethod: parseInt(this.shareVia),
                    businessId: parseInt(this.idBusinessForWallet)
                }));

            if (clientData.length === 0) {
                swal.fire({
                    position: "center",
                    type: "warning",
                    title: this.$t('noHayCorreosElectronicos'),
                    text: this.$t('ningunClienteConCorreoElectronico'),
                    showConfirmButton: true,
                    confirmButtonText: this.$t('vale'),
                });
                return;
            }

            var config = {
                params: {
                    idCompany: this.idCompany,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            const payload = { clients: clientData };

            let vm = this;
            this.axios.post(this.$store.getters.apiUrl + "clients/generatePassbookURLs", payload, config)
                .then(function (response) {

                    const results = response.data;
                    const allSuccess = results.every(result => result.status === "success");

                    if (allSuccess) {
                        swal.fire({
                            position: "center",
                            type: "success",
                            title: "Correos enviados",
                            text: "Los correos se enviaron correctamente.",
                            showConfirmButton: true,
                            confirmButtonText: "Perfecto",
                        });
                    } else {
                        const failedClients = results.filter(result => result.status !== "success");
                        const failedMessages = failedClients.map(client => `Cliente ID ${client.clientId}: ${client.message}`).join('\n');

                        swal.fire({
                            position: "center",
                            type: "error",
                            title: "Error al enviar",
                            text: `No se pudieron enviar todos los correos:\n\n${failedMessages}`,
                            showConfirmButton: true,
                            confirmButtonText: "Entendido",
                        });
                    }
                })
                .catch(function (error) {
                    swal.fire({
                        position: "center",
                        type: "error",
                        title: "Error al enviar",
                        text: "Ocurrió un error inesperado. Por favor, inténtelo de nuevo más tarde.",
                        showConfirmButton: true,
                        confirmButtonText: "Entendido",
                    });
                });
        },
        searchCasas() {
            if (this.searchQuery !== undefined && this.searchQuery !== "") {
                this.$router.push({ name: 'search-clientes', params: { query: this.searchQuery } }).catch(() => {});
                this.isSearch = true;
            } else if (this.isSearch) {
                this.isSearch = false;
                this.$router.push({ name: 'clientes' }).catch(() => {});
                this.getClientes();
            }
        },
        removeSearch() {
            if (this.searchQuery && this.searchQuery !== "") {
                this.searchQuery = "";
                this.isSearch = false;
                this.$router.push({ name: 'clientes' }).catch(() => {});
                this.getClientes()
            }
        },
        
        onMostrarBajasChange() {
            this.pag = 1;
            this.totalPags = 0;
            this.listClientes = [];
            this.getClientes();
        },

        openModalImportarClientes() {
            this.$modal.show("importar-excel-clientes-valderrama");
        },

        openModalImportarTarjetas() {
            this.$modal.show("importar-excel-tarjetas-procavi");
        },

        openSendWalletModal() {
            this.$modal.show("enviar-passboks");
        },

        closeSendWalletModal() {
            this.$modal.hide("enviar-passboks");
        },

        showModalPassbooks(idCliente) {
            this.idClientForPassbooks = 0;
            this.loadingForWallet = Loading.service({ text: this.$t('cargando') });
            this.idClientForPassbooks = idCliente;
            this.getBusinessByCompany(this.idCompany);
            this.getCliente(idCliente);
            if (this.idClientForPassbooks > 0) {
                this.$modal.show("compartir-passboks");
                this.loadingForWallet.close();
            }
        },

        hideModalPassboks() {
            this.$modal.hide("compartir-passboks");
            this.idClientForPassbooks = 0;
        },

        showModalUpdateClientData() {
            this.$modal.show("update-client-info");
        },

        hideModalUpdateClientData() {
            this.$modal.hide('update-client-info');
        },

        onFileChange(e) {
            this.file = e;
        },

        previewClientData() {
            if (this.file) {
                const company = this.listCompany.filter((el) => el.id === this.idCompany);

                if (company.length === 0) {
                    swal({
                        title: this.$t('atencion'),
                        text: this.$t('tienesQueSeleccionarUnArchivoDeImportacion'),
                        confirmButtonClass: "btn btn-info btn-fill",
                        type: "error",
                    });
                    return;
                }

                this.nameCompany = company[0].name;

                let e = this.file;
                var files = e.target.files;
                var reader = new FileReader();
                var vm = this;

                reader.onload = function (e) {
                    var data = new Uint8Array(e.target.result);
                    var workbook = XLSX.read(data, { type: "array", cellDates: true });
                    let sheetName = workbook.SheetNames[0];
                    let worksheet = workbook.Sheets[sheetName];

                    // Convertir el contenido del Excel a un array JSON
                    const datosClientes = XLSX.utils.sheet_to_json(worksheet);
                    let rango = XLSX.utils.decode_range(worksheet["!ref"]);
                    vm.lineasXml = rango.e.r;

                    // console.log(vm.idCompany);

                    // Redirigir a la nueva ruta con los datos procesados
                    // vm.$router.push({
                    //     name: 'import-clientes',
                    //     query: {
                    //         data: JSON.stringify(datosClientes),
                    //         idCompany: vm.idCompany,
                    //     },
                    // });

                    vm.$router.push({
                        name: 'import-clientes',
                        params: { datosClientes: datosClientes, idCompany: vm.idCompany }
                    });
                };

                reader.readAsArrayBuffer(files[0]);
            } else {
                swal({
                    title: this.$t('atencion'),
                    text: this.$t('tienesQueSeleccionarUnArchivoDeImportacion'),
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "error",
                });
            }
        },

        previewTarjetasData() {
            if (this.file) {
                const company = this.listCompany.filter((el) => el.id === this.idCompany);

                if (company.length === 0) {
                    swal({
                        title: this.$t('atencion'),
                        text: this.$t('tienesQueSeleccionarUnArchivoDeImportacion'),
                        confirmButtonClass: "btn btn-info btn-fill",
                        type: "error",
                    });
                    return;
                }

                this.nameCompany = company[0].name;

                let e = this.file;
                var files = e.target.files;
                var reader = new FileReader();
                var vm = this;

                reader.onload = function (e) {
                    var data = new Uint8Array(e.target.result);
                    var workbook = XLSX.read(data, { type: "array", cellDates: true });
                    let sheetName = workbook.SheetNames[0];
                    let worksheet = workbook.Sheets[sheetName];

                    // Convertir el contenido del Excel a un array JSON
                    const datosTarjetas = XLSX.utils.sheet_to_json(worksheet);
                    let rango = XLSX.utils.decode_range(worksheet["!ref"]);
                    vm.lineasXml = rango.e.r;

                    // console.log(vm.idCompany);

                    // Redirigir a la nueva ruta con los datos procesados
                    // vm.$router.push({
                    //     name: 'import-tarjetas',
                    //     query: {
                    //         data: JSON.stringify(datosTarjetas),
                    //         idCompany: vm.idCompany,
                    //     },
                    // });

                    vm.$router.push({
                        name: 'import-tarjetas',
                        params: { datosTarjetas: datosTarjetas, idCompany: vm.idCompany }
                    });
                };

                reader.readAsArrayBuffer(files[0]);
            } else {
                swal({
                    title: this.$t('atencion'),
                    text: this.$t('tienesQueSeleccionarUnArchivoDeImportacion'),
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "error",
                });
            }
        },

        openModal() {
            if (this.file) {
                this.$modal.show("modal-importar");

                const company = this.listCompany.filter((el) => {
                    return this.idCompany == el.id;
                });

                if (company.length == 0) {

                } else {
                    this.nameCompany = company[0].name;
                }

                let e = this.file;

                var files = e.target.files,
                    f = files[0];
                var reader = new FileReader();
                var vm = this;

                reader.onload = function (e) {
                    var data = new Uint8Array(e.target.result);

                    var workbook = XLSX.read(data, { type: "array", cellDates: true });
                    let sheetName = workbook.SheetNames[0];

                    let worksheet = workbook.Sheets[sheetName];

                    vm.listDatos = XLSX.utils.sheet_to_json(worksheet);

                    let rango = XLSX.utils.decode_range(worksheet["!ref"]);

                    vm.lineasXml = rango.e.r;
                };

                reader.readAsArrayBuffer(f);
            } else {
                swal({
                    title: this.$t('atencion'),
                    text: this.$t('tienesQueSeleccionarUnArchivoDeImportacion') + " ",
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "error",
                });
            }
        },

        cerrarModal() {
            this.$modal.hide("modal-importar");
        },

        importar() {
            if (this.file) {
                let e = this.file;

                var files = e.target.files,
                    f = files[0];
                var reader = new FileReader();
                var vm = this;

                reader.onload = function (e) {
                    var data = new Uint8Array(e.target.result);

                    var workbook = XLSX.read(data, { type: "array", cellDates: true });
                    let sheetName = workbook.SheetNames[0];

                    let worksheet = workbook.Sheets[sheetName];

                    vm.listDatos = XLSX.utils.sheet_to_json(worksheet);

                    //PETICION DE GUARDAR
                    vm.importarClientes();
                };

                reader.readAsArrayBuffer(f);
                vm.cerrarModal();
            } else {
                swal({
                    title: this.$t('atencion'),
                    text: this.$t('tienesQueSeleccionarUnArchivoDeImportacion'),
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "error",
                });
            }
        },

        importarClientes() {
            this.loadingGeneral = Loading.service({ text: this.$t('importandoDatos') });

            var config = {
                params: {
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            var params = {
                idCompany: this.idCompany,
                listDatos: this.listDatos,
            };

            let vm = this;
            let controller = "importarClientes";

            this.axios
                .post(
                    this.$store.getters.apiUrl + "clients/" + controller,
                    params,
                    config
                )
                .then(function (response) {
                    if (response.data.response) {
                        vm.loadingGeneral.close();
                    } else {
                        vm.loadingGeneral.close();
                    }

                    vm.$modal.hide("modal-importar");
                    vm.$modal.hide("importar-excel-clientes-valderrama");
                    vm.getClientes();
                })
                .catch(function (error) {
                    vm.loadingGeneral.close();
                    console.log(error);
                });
        }
    }

}
</script>

<style scoped>
[v-cloak] {
    display: none;
}

tbody tr:hover {
    background-color: rgba(0, 153, 130, 0.2);
}

tbody td {
    padding: 0 !important;
}

td div {
    padding: 12px 8px;
    color: #333;
}

.buttonsSearch:hover {
    cursor: pointer;
    background-color: rgba(0, 153, 130, 0.1);
}

.card {
    padding: 20px;
}

.input-group button {
    height: 40px;
}

.tooltip {
    position: relative;
    display: inline-block;
}

.tooltip .tooltiptext {
    visibility: hidden;
    width: 140px;
    background-color: black;
    color: #fff;
    text-align: center;
    padding: 5px;
    border-radius: 6px;

    /* Posiciona el tooltip encima del botón */
    position: absolute;
    z-index: 1;
    bottom: 125%;
    /* Posiciona 25% más arriba del elemento */
    left: 50%;
    margin-left: -70px;
    /* Ajusta para centrar el tooltip */
    opacity: 0;
    transition: opacity 0.3s;
}

.tooltip .tooltiptext::after {
    content: "";
    position: absolute;
    top: 100%;
    /* Posiciona la flecha abajo del tooltip */
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: black transparent transparent transparent;
}

.tooltip.show .tooltiptext {
    visibility: visible;
    opacity: 1;
}

h6 .wallet {
    text-transform: lowercase;
}

.disabled-button {
    pointer-events: none;
    opacity: 0.5;
}

.search-con-check {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 10px;
}
.search-con-check__input {
    flex: 0 0 auto;
    width: 33%;
    min-width: 26rem;
}
.search-con-check__label {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-weight: normal;
    white-space: nowrap;
    margin-bottom: 0;
}
@media (max-width: 767px) {
    .search-con-check {
        flex-wrap: wrap;
    }
    .search-con-check__input {
        flex: 1 1 100%;
        width: 100%;
    }
    .search-con-check__label {
        margin-left: auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Configuracion/Clientes/Clientes.vue